/**
 * Created by daniel.plotkin on 01/01/2018.
 */

import { Directive, ElementRef, Output, EventEmitter, HostListener, Input, OnInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[clickOutside]'
})
export class ClickOutsideDirective  implements OnInit, OnDestroy {

  @Input() clickOutsideEvent?: string;
  @Output()
  public clickOutside = new EventEmitter<MouseEvent>();
  onClickHandler: EventListener;

  constructor(private _elementRef: ElementRef) {
  }

  ngOnInit(): void {
    this.clickOutsideEvent = this.clickOutsideEvent || 'mouseup';
    this.onClickHandler = this.onClick.bind(this);
    document.addEventListener(this.clickOutsideEvent, this.onClickHandler);
  }

  ngOnDestroy(): void {
    document.removeEventListener(this.clickOutsideEvent, this.onClickHandler);
  }

  public onClick(event: MouseEvent): void {
    let targetElement: HTMLElement = event.target as HTMLElement;
    if (!targetElement) {
      return;
    }

    const clickedInside = this._elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.clickOutside.emit(event);
    }
  }
}
